export default __webpack_public_path__ + "static/media/speed-idle.f6029c82.jpg";